import lodashMerge from 'lodash.merge'

export default {
  setSettings(state, settings = {}) {
    lodashMerge(state, settings)
  },
  setPalette(state, palette = []) {
    state.palette = palette
  },
  setSEO(state, seo = {}) {
    state.seo = { ...state.seo, ...seo }
  },
  setJavascript(state, js = {}) {
    state.javascript = { ...state.javascript, ...js }
  },
  addColor(state, color = '#FFFFFF') {
    state.palette.push(color)
  },
  removeColor(state, color = '#FFFFFF') {
    state.palette = state.palette.filter(c => c !== color)
  },
}
